import { useState } from "react";

const QuantityGrid = ({ grid }) => {
    const [number, setNumber] = useState(1);
    const onClickMinusHandler = () => {
        if (number - 1 === 0) {
            setNumber(1);
            let XY = 100 / 1;
            grid(XY, 1);
        } else {
            setNumber(number - 1);
            let XY = 100 / (number - 1);
            grid(XY, number - 1);
        }
    };
    const onClickPlusHandler = () => {
        setNumber(number + 1);
        let XY = 100 / (number + 1);
        grid(XY, number + 1);
    };

    return (
        <div className="quantity">
            <input type="button" value="-" onClick={onClickMinusHandler} />
            <input
                type="text"
                min="1"
                max="10"
                onChange={() => number}
                value={number}
            />
            <input type="button" value="+" onClick={onClickPlusHandler} />
        </div>
    );
};

export default QuantityGrid;
